import { t } from "i18next";
import React, {useState} from "react";
import { Form, Row, Col} from "react-bootstrap"
import { useSelector } from "react-redux";

import '../../css/ProfileCard.css'
import clientService from "../../services/client.service";
import sapFieldGlassLogo from '../../images/sapFieldGlass.png';
import PropTypes from 'prop-types';
import { getStateName } from "./Functions";

const ProfileCard = (props) => {

    const [product, setProduct] = useState(props.product);
    const [key, setKey] = useState(null);
    
    const { user: currentAuth } = useSelector((state) => state.auth);


    const showWorkwith = props.showWorkwith;
    const state = t(getStateName(product));

    const handleActivate = (e) => {
        e.preventDefault();
        //Funcionalidad de activar. Esta compara la clave ingresada por el cliente contra la clave tpt. Si son iguales, se almacena la clave cliente.
        //Si no son iguales, se retorna mensaje de error.

        let _product  = product;
        _product.clientId = props.clientId;
        _product.clientKey = key;

        clientService.activateProductSuscriptions(_product).then((response) => {          
            setProduct(response.data.data);
        }).catch((e) => {
        });
    };
    
    const handleSuscribe = (e) => {
        e.preventDefault();
        //Funcionalidad de contratar. Crea un registro de cliente/producto.
        let _product  = product;
        _product.clientId = props.clientId;
        
        clientService.createProductSuscriptions(_product).then((response) => {          
            const _product = response.data.data;
            setProduct(_product);
        }).catch((e) => {
        });
    };

    const handleUnsuscribe = (e) => {
        e.preventDefault();
        //Funcionalidad de descontratar. Esta borra la clave cliente y la clave tpt. Envia correo indicando que producto ha sido descontratado.
        let _product  = product;
        _product.clientId = props.clientId;

        clientService.removeProductSuscriptions(_product).then((response) => {
            response.data.data.tptKey = null;
            setProduct(response.data.data);
        }).catch((e) => {
        });
    };

    const handleKeyChange = (e) => {
        e.preventDefault();

        setKey(e.target.value);
    };

    const handleGenerateKey = (e) => {
        e.preventDefault();

        let _product  = product;
        _product.clientId = props.clientId;

        clientService.generateProductKeySuscriptions(_product).then((response) => {          
            setProduct(response.data.data);
        }).catch((e) => {
        });
    };

    return (
        <Col md={12} lg={6} xl={4} xxl={3} className="p-3">   
            <div className="price-item text-center popular">
                <div className="price-top">
                    <h4>{product.name}</h4>
                    <p className="text-dark">{product.title}</p>
                    {showWorkwith &&
                        <p className="text-dark" >(Works with <img className="pb-1" src={sapFieldGlassLogo} alt="sapFieldGlass"></img>)</p>
                    }
                    {!showWorkwith &&
                        <p className="text-dark" >&nbsp;</p>
                    }
                    <h2 className="mb-0">{state}</h2>
                    <h2 className="mb-0">{state === t('data-lang-lbl-suscribe')?<><sup>$</sup>{product.price}</> : <>&nbsp;</>}</h2>
                    <span className="text-capitalize">{state === t('data-lang-lbl-suscribe')? product.pricePeriod : <>&nbsp;</>}</span>
                </div>
                <div className="price-content text-start text-white mt-3">
                    <Row style={{height: "60%"}} className="col-xl-12 border-bottom">
                        {state === t('data-lang-lbl-suscribed') &&
                            <span className="c-black">{t('data-lang-msg-suscriptionpending')}</span>
                        }
                        {state === t('data-lang-lbl-payvalidated') &&
                            <span className="c-black">{t('data-lang-msg-suscriptionvalidated')}</span>
                        }
                        {state === t('data-lang-lbl-suscribe') &&
                            <span className="c-black">{product.description}</span>
                        }
                        {state === t('data-lang-lbl-buyed') &&
                            <span className="c-black">{t('data-lang-msg-suscriptiondone')}</span>
                        }
                    </Row>
                    <fieldset style={{"height": "50%"}}>
                        <div style={{"height": "100%"}}>
                            <Row className="align-items-center" style={{"height": "50%"}}>
                                {(state === t('data-lang-lbl-suscribed') || state === t('data-lang-lbl-payvalidated')) &&
                                    <>
                                        <Form.Group as={Col} className="col-lg-3">
                                            <Form.Label className="text-white"><h5>{t('data-lang-lbl-key')}</h5></Form.Label>
                                        </Form.Group>
                                        <Form.Group as={Col} className="col-lg-9">
                                            <Form.Control
                                                disabled={state === t('data-lang-lbl-suscribed') ? "disabled" : ""}
                                                type="password"
                                                className="form-control"
                                                name="product"
                                                placeholder="XXXX-XXXXX-XXXX-XXXXX-XX"
                                                autoComplete="off"
                                                onChange={handleKeyChange}
                                            />
                                        </Form.Group>
                                    </>
                                }
                            </Row>
                            <Row>
                                <Form.Group as={Col}>
                                    {(state === t('data-lang-lbl-suscribed') || state === t('data-lang-lbl-payvalidated')) &&
                                        <button onClick={handleActivate} disabled={state === t('data-lang-lbl-suscribed') ? "disabled" : ""} className="btn btn-light col-12 mt-2">{t('data-lang-btn-activate')}</button>
                                    }
                                    {(state === t('data-lang-lbl-suscribe')) &&
                                        <button onClick={handleSuscribe} className="btn btn-light col-12 mt-2">{t('data-lang-btn-suscribe')}</button>
                                    }
                                    {(state === t('data-lang-lbl-buyed')) &&
                                        <button onClick={handleUnsuscribe} className="btn btn-light col-12 mt-2">{t('data-lang-btn-unsuscribe')}</button>
                                    }
                                </Form.Group>
                            </Row>
                        </div>
                    </fieldset>
                </div>
            </div>

            {(currentAuth.profile.includes("sAdmin") && (state === t('data-lang-lbl-suscribed') || state === t('data-lang-lbl-buyed') || state === t('data-lang-lbl-payvalidated'))) &&
            <div className="price-item text-center popular mt-5">
                <h3><Form.Label className="text-white"><h5>{t('data-lang-lbl-generatekey')}</h5></Form.Label></h3>
                <div style={{maxHeight: "150px"}} className="price-content text-start text-white mt-3">
                    <Row>
                        <Form.Group as={Col} className="col-lg-3">
                            <Form.Label className="text-white"><h5>{t('data-lang-lbl-key')}</h5></Form.Label>
                        </Form.Group>
                        <Form.Group as={Col} className="col-lg-9">
                            <Form.Control
                                disabled="disabled"
                                type="text"
                                className="form-control"
                                name="productTptKey"
                                placeholder="XXXX-XXXXX-XXXX-XXXXX-XX"
                                autoComplete="off"
                                value={product.tptKey !== null ? product.tptKey : ""}
                            />
                        </Form.Group>
                        {!product.withTptKey &&
                            <Form.Group as={Col} className="col-lg-12">
                                <button onClick={handleGenerateKey} className="btn btn-light col-12 mt-2">{t('data-lang-btn-generate')}</button>
                            </Form.Group>
                        }
                    </Row>                    
                </div>
            </div>
            }
        </Col>
    );
};
ProfileCard.propTypes = {
    clientId: PropTypes.string.isRequired,
    product: PropTypes.object.isRequired,
    showWorkwith: PropTypes.bool.isRequired,
};
export default ProfileCard;